export const isAvailableOptions = [
  { optionValue: true, label: "En stock" },
  { optionValue: false, label: "En rupture" },
];

export const isPublicisedOptions = [
  { optionValue: false, label: "Sans pub" },
  { optionValue: true, label: "Avec pub" },
];
